var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import { isNull } from 'lodash';
import moment from 'moment-timezone';
import React, { useState } from 'react';
import { deleteMedicationList } from '../../Async/MedicationListsAsync';
import { displayError, displayMessage } from '../../Config/ApplicationConfig';
import { MedicationListStatus, MedicationListType } from '../../Contracts/MedicationListsSearchFilter.Request';
import { UseAsyncStatus } from '../../Hooks/useAsync';
import { MedicationLocale } from '../../Medications.en';
import { MedicationsPermissions } from '../../MedicationsPermissions';
import { getFirstErrorMessageFromApiError, isDomainValidationError } from '../../Shared/DomainValidationFunctions';
import { iconLight, successGlowBorder, warningGlowBorder, white } from '../../Styles/Colours';
import { PermissionsCheck } from '../Auth/PermissionsCheck';
import { Button, ButtonMode } from '../Button';
import { DeleteDialog } from '../DeleteDialog/DeleteDialog';
import { EditIcon, LockClosedIcon, LockOpenIcon, PlusIcon, TrashCanIcon } from '../Icons';
import { LayoutCentral } from '../LayoutCentral';
import { LoadingPlaceholder } from '../Placeholder';
import { NoMedicationList } from '../SplashScreens/NoMedicationList';
import { NoResults } from '../SplashScreens/NoResults';
import { DataTable, HoverOnlyButtonGroup } from './DataTable';
import styles from './MedicationListsDataTable.module.css';
var columnExtensions = [
    {
        columnName: 'name'
    },
    {
        columnName: 'updatedBy'
    },
    {
        columnName: 'type',
        width: 200
    },
    {
        columnName: 'status',
        width: 150
    },
    {
        columnName: 'actions',
        align: 'right',
        width: 110
    }
];
var CustomStyledTableHeaderCell = function (cellProps) {
    return React.createElement(TableHeaderRow.Cell, __assign({}, cellProps, { className: styles.headerCell }));
};
var CustomStyledTableCell = function (cellProps) {
    return React.createElement(Table.Cell, __assign({}, cellProps, { className: styles.cell }));
};
var StatusCell = function (cellProps) {
    var status = cellProps.tableRow.row.status;
    if (status === null)
        return React.createElement(CustomStyledTableCell, __assign({}, cellProps));
    var statusClass, copy, statusIcon;
    if (status === MedicationListStatus.Published) {
        statusClass = styles.published;
        copy = 'Published';
        statusIcon = React.createElement(LockClosedIcon, { size: '16', color: successGlowBorder, style: { marginRight: '5px' } });
    }
    else {
        statusClass = styles.draft;
        copy = 'Draft';
        statusIcon = React.createElement(LockOpenIcon, { size: '16', color: warningGlowBorder, style: { marginRight: '5px' } });
    }
    return (React.createElement(CustomStyledTableCell, __assign({}, cellProps),
        React.createElement("span", { className: classNames(styles.statusCell, statusClass) },
            statusIcon,
            copy)));
};
var NameByCell = function (cellProps) {
    var name = cellProps.tableRow.row.name;
    return (React.createElement(CustomStyledTableCell, __assign({}, cellProps),
        React.createElement(Tooltip, { title: name, placement: 'bottom-start' },
            React.createElement("span", null, name))));
};
var UpdatedByCell = function (cellProps) {
    var updatedBy = cellProps.tableRow.row.lastUpdatedBy;
    var updatedOn = cellProps.tableRow.row.lastUpdatedOn;
    var parsed = moment(updatedOn, 'YYYY-MM-DDThh:mm:ss.SSSSSSZ');
    var dateOutput = parsed.format('D MMMM YYYY');
    var timeOutput = parsed.format('HH:mm');
    return (React.createElement(CustomStyledTableCell, __assign({}, cellProps),
        React.createElement(Tooltip, { title: updatedBy, placement: 'bottom-start' },
            React.createElement("span", null, updatedBy)),
        React.createElement("div", { className: styles.updatedOn }, dateOutput + " at " + timeOutput)));
};
var TypesCell = function (cellProps) {
    var types = cellProps.tableRow.row.types;
    if (types === [])
        return React.createElement(CustomStyledTableCell, __assign({}, cellProps));
    var id = cellProps.tableRow.row.authoringSystemForeignKey;
    var typesListItems = types.map(function (item, key) {
        if (item === MedicationListType.ScopeOfPracticeList)
            return React.createElement("li", { key: id + "1" }, "Scope of practice");
        if (item === MedicationListType.Formulary)
            return React.createElement("li", { key: id + "2" }, "Formulary");
        if (item === MedicationListType.DefaultList)
            return React.createElement("li", { key: id + "3" }, "Default list");
        return;
    });
    return (React.createElement(CustomStyledTableCell, __assign({}, cellProps),
        React.createElement("ul", { className: styles.typesList }, typesListItems)));
};
var CustomCellComponent = function (cellProps) {
    switch (cellProps.column.name) {
        case 'name':
            return React.createElement(NameByCell, __assign({}, cellProps));
        case 'status':
            return React.createElement(StatusCell, __assign({}, cellProps));
        case 'type':
            return React.createElement(TypesCell, __assign({}, cellProps));
        case 'updatedBy':
            return React.createElement(UpdatedByCell, __assign({}, cellProps));
        default:
            return React.createElement(CustomStyledTableCell, __assign({}, cellProps));
    }
};
export function MedicationListsDataTable(props) {
    var _this = this;
    var _a;
    var isLoading = props.loadStatus === UseAsyncStatus.Loading || props.loadStatus === UseAsyncStatus.Reloading;
    var _b = __read(useState(null), 2), listToDelete = _b[0], setListToDelete = _b[1];
    var columns = [
        {
            name: 'name',
            title: 'Name',
            getCellValue: function (row) { return row.name; }
        },
        {
            name: 'updatedBy',
            title: 'Updated by',
            getCellValue: function (row) { return row.lastUpdatedBy + " " + row.lastUpdatedOn; }
        },
        {
            name: 'type',
            title: 'Type',
            getCellValue: function (row) { return row.types.map(function (item) { return item.toString(); }); }
        },
        {
            name: 'status',
            title: 'Status',
            getCellValue: function (row) { return row.status; }
        },
        {
            name: 'actions',
            title: 'Actions',
            getCellValue: function (row) { return (React.createElement(HoverOnlyButtonGroup, null,
                React.createElement("div", { className: styles.hoverOnlyButtons },
                    React.createElement(PermissionsCheck, { permission: MedicationsPermissions.WriteMedicationLists },
                        row.status !== MedicationListStatus.Published && (React.createElement(Button, { mode: ButtonMode.text, noShadowOnHover: true, iconOnly: true, tooltip: 'Edit', testId: 'medication-list-item-edit', onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                props.onEditClick(row);
                            } },
                            React.createElement(EditIcon, { color: iconLight, size: '20', noPadding: true }))),
                        React.createElement(Button, { mode: ButtonMode.text, noShadowOnHover: true, iconOnly: true, tooltip: 'Delete', testId: 'medication-list-item-delete', onClick: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                setListToDelete(row);
                            } },
                            React.createElement(TrashCanIcon, { color: iconLight, size: '20', noPadding: true })))))); }
        }
    ];
    if (props.loadStatus === UseAsyncStatus.Loading || props.loadCount === 0) {
        return (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    }
    var medicationLists = (_a = props.medicationLists) !== null && _a !== void 0 ? _a : [];
    if (props.loadStatus === UseAsyncStatus.Reloading && medicationLists.length === 0) {
        return (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    }
    if (props.loadStatus === UseAsyncStatus.Loaded && props.filtered && medicationLists.length === 0) {
        return (React.createElement(LayoutCentral, null,
            React.createElement(NoResults, { title: 'No medication lists found. Refine your search and try again.' })));
    }
    var noMedicationListsInTheSystem = !props.filtered && medicationLists.length === 0;
    if (props.loadStatus === UseAsyncStatus.Loaded && noMedicationListsInTheSystem) {
        return (React.createElement(LayoutCentral, null,
            React.createElement("div", { className: styles.noResultsContainer },
                React.createElement(NoMedicationList, { title: React.createElement("span", null,
                        "Create your first medication list",
                        React.createElement("br", null),
                        "to define your default number of packs, duration, and dosage instructions.") }),
                !!props.onAddMedicationList && (React.createElement(Button, { onClick: props.onAddMedicationList, testId: 'create-roster', startIcon: React.createElement(PlusIcon, { size: '16', color: white }) }, "Add medication list")))));
    }
    return (React.createElement("div", { className: styles.dataTableContainer },
        React.createElement(DataTable, { testId: 'medication-list', columns: columns, data: medicationLists, cellComponent: CustomCellComponent, headerComponent: CustomStyledTableHeaderCell, columnExtensions: columnExtensions, getRowId: function (item) { return item.id; }, limit: props.limit, loading: isLoading, disableColumnSorting: true, rowSelection: {
                selectedIds: [],
                onSelect: function (row) {
                    props.onEditClick(row);
                }
            } }),
        !!listToDelete && (React.createElement(DeleteDialog, { title: 'Delete item', testId: 'delete-medication-list', onCancel: function (e) {
                e.preventDefault();
                e.stopPropagation();
                setListToDelete(null);
            }, onOk: function (e) { return __awaiter(_this, void 0, void 0, function () {
                var err_1, errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (isNull(listToDelete))
                                return [2 /*return*/];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            e.preventDefault();
                            e.stopPropagation();
                            return [4 /*yield*/, deleteMedicationList(listToDelete.id)];
                        case 2:
                            _a.sent();
                            displayMessage('Medication List removed');
                            props.onDelete();
                            return [3 /*break*/, 5];
                        case 3:
                            err_1 = _a.sent();
                            errorMessage = 'Unable to remove Medication List';
                            if (isDomainValidationError(err_1)) {
                                errorMessage = getFirstErrorMessageFromApiError(err_1, MedicationLocale);
                            }
                            displayError(errorMessage);
                            return [3 /*break*/, 5];
                        case 4:
                            setListToDelete(null);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); } },
            "Are you sure you want to remove ", listToDelete === null || listToDelete === void 0 ? void 0 :
            listToDelete.name,
            "?"))));
}
